module.exports = __webpack_public_path__ + "img/4.48c1298e.jpg";